import { useEffect, useState } from 'react';
import TextWinds from '../../../components/common/TextWinds';
import { NormalPage } from '../../../components/layout/page/NormalPage';
import MyClassCard from './component/MyClassCard';
import { NormalPageTitle } from '../../../components/layout/page/NormalPageTitle';
import instance from '../../../api/axios/utils.ts/instance';
import { useAppDispatch } from '../../../store/hook';
import { openModal } from '../../../store/features/modalSlice';
import ModalExtendLink from '../../../components/modal/ModalExtendLink';

const ClassManagement = () => {
  const dispatch = useAppDispatch();
  const [data, setData] = useState([]);
  const handleExtend = (courseId: string) => {
    dispatch(
      openModal({
        body: <ModalExtendLink courseId={courseId} />,
      }),
    );
  };

  useEffect(() => {
    // API 호출 함수
    const fetchData = async () => {
      try {
        const response = await instance.get('/v1/my-class');
        const res = response.data;
        setData(res.data);
      } catch (error) {}
    };

    fetchData(); // 데이터 가져오기 함수 호출
  }, []);

  return (
    <NormalPage>
      <NormalPageTitle title="클래스 관리" />
      <section className="xl:bg-skyblue_5">
        <div className="mx-auto flex w-full flex-wrap gap-[22px] pb-[64px] pt-3.5 xl:max-w-page">
          {data.length > 0 ? (
            data.map((item, index) => (
              <MyClassCard
                key={index}
                data={item.myClass}
                linkTo={`/lms/${item.myClass.id}/dashboard`}
                openExtend={() => handleExtend(item.course.id)}
              />
            ))
          ) : (
            <div className="flex w-full flex-col">
              <TextWinds type="title_h2" className="mt-3 w-full text-center">
                아직 개설된 클래스가 없습니다.
              </TextWinds>
              <br />
              <TextWinds type="title_h2" className="w-full text-center">
                코스를 수료하신 후 클래스를 이용하세요.
              </TextWinds>
            </div>
          )}
        </div>
      </section>
      {/* <div className="mt-[64px] xl:absolute xl:top-[18px] xl:w-[177px] xl:right-[50%] xl:mt-0 xl:translate-x-2/4 xl:mr-[-498px]">
            <Buttons type="outlined" color="purple5">
                내 학습 이용 메뉴얼
            </Buttons>
        </div> */}
    </NormalPage>
  );
};

export default ClassManagement;
